import { router } from "@inertiajs/vue3"
import { onMounted, onUnmounted } from "vue"

import { subscribeToOrder, type AblySubscription } from "../services/cable"

type OrderUpdatedPayload = {
  type: string
  order_id: string
  order_gid: string
  status: string
}

export function useOrderSubscription(orderId: string) {
  let subscription: AblySubscription | null = null

  onMounted(() => {
    void (async () => {
      subscription = await subscribeToOrder<OrderUpdatedPayload>(
        orderId,
        (data) => {
          if (data?.type === "order_updated") {
            router.reload()
          }
        },
      )
    })()
  })

  onUnmounted(() => {
    if (subscription) {
      subscription.close()
      subscription = null
    }
  })
}
